import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faX } from '@fortawesome/free-solid-svg-icons';
import '../style/HamburgerMenu.css';
import { useCart } from '../contexts/CartContext';
import { useCartMenu } from '../contexts/CartMenuContext';

const Cart = () => {
    const { cartItems } = useCart();
    const { setIsCartOpen } = useCartMenu();

    return (
    <div>
        <div className="cart-container">
            <FontAwesomeIcon
                className="account-section-icon"
                icon={faCartShopping}
                onClick={() => setIsCartOpen(true)}
            />
            {cartItems.length > 0 && 
                <p className="cart-number">
                    {cartItems.reduce((total, item) => total + item.numberOfItems, 0)}
                </p>
            }
        </div>
    </div>
    
    );
};

export default Cart;
